import object from 'helpers/object'


export const initialState = {
  isFetching: false,
  dates: [],
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setDates = (state, payload) => (
  object.setIn(state, [ 'dates' ], payload)
)
